import { render } from "./Varieties.vue?vue&type=template&id=57922a50"
import script from "./Varieties.vue?vue&type=script&lang=ts"
export * from "./Varieties.vue?vue&type=script&lang=ts"
script.render = render

export default script